import Vue from 'vue'

export default Vue.extend({
  template: `
        <div style="width: 200px !important;" class="mt-3">
            <b-progress :value="this.params.valueFormatted" show-progress></b-progress>
        </div>
  `,
  mounted() {}
})
